import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { DEL_DELEGATE_CIRCULAR_ACTION_TYPE, GET_DELEGATE_CIRCULAR_COMPANY_ACTION_TYPE, GET_DELEGATE_CIRCULAR_LIST_ACTION_TYPE, INSERT_DELEGATE_CIRCULAR_ACTION_TYPE, delegateAssignCircularUrl, deleteDelegateCircularUrl, getDelegateCircularCompanyUrl, getDelegateCircularListUrl, headers, insertUpdateDelegateCircularUrl, DELEGATE_ASSIGN_CIRCULAR_ACTION_TYPE } from "../../../utils/constants";


export const getDelagateCircularCompany_action = (PaymentTypeID, ExhibitorTypeID, companyName) => async (dispatch) => {
    try {
        const params = {
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            PaymentTypeID: PaymentTypeID,
            ExhibitorTypeID: ExhibitorTypeID,
            CompanyName: companyName
        }

        const res = await axiosGet(getDelegateCircularCompanyUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_CIRCULAR_COMPANY_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateDelagateCircular_action = (circularId, circularDate, circularTitle, circularFile, list, circularFileType, isSendMail) => async (dispatch) => {
    try {
        const mapData = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            DelegateCircularID: circularId != '' ? circularId : null,
            DelegateCircularDate: circularDate,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            title: circularTitle,
            Attachment: circularFile,
            circularListData: list,
            AttachmentType: circularFileType,
            isSendMail: isSendMail
        }
        console.log("insertDelagateCircular_action Action------->", mapData)

        const res = await axiosPost(insertUpdateDelegateCircularUrl, mapData, headers)

        dispatch({
            type: INSERT_DELEGATE_CIRCULAR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelagateCircularList_action = () => async (dispatch) => {
    try {
        const params = {
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID
        }
        console.log("getCircularList_action Action------->", params)

        const res = await axiosGet(getDelegateCircularListUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_CIRCULAR_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const delDelagateCircular_action = (circularId) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            DelegateCircularID: circularId
        }
        console.log("delCircular_action Action------->", params)

        const res = await axiosGet(deleteDelegateCircularUrl, params, headers)

        dispatch({
            type: DEL_DELEGATE_CIRCULAR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const assignCircular_action = (list, list2, flag, isSendMail) => async (dispatch) => {
    try {
        const mapData = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            circularListData: list,
            circularList: list2,
            isFlag: flag,
            isSendMail: isSendMail
        }
        console.log("assignCircular_action Action------->", mapData)

        const res = await axiosPost(delegateAssignCircularUrl, mapData, headers)

        dispatch({
            type: DELEGATE_ASSIGN_CIRCULAR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}